/* tslint:disable */
/* eslint-disable */
/**
 * ROC API
 * Referral Outbound Center (ROC) API for managing outbound referrals between post-acute care facilities.  All endpoints require a valid JWT. Organization and user identity are derived from the token — callers never pass these in query params or request bodies. 
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type CreateDocumentRequest,
    CreateDocumentRequestFromJSON,
    CreateDocumentRequestToJSON,
} from '../models/CreateDocumentRequest';
import {
    type CreateDocumentUploadUrlRequest,
    CreateDocumentUploadUrlRequestFromJSON,
    CreateDocumentUploadUrlRequestToJSON,
} from '../models/CreateDocumentUploadUrlRequest';
import {
    type CreateMessageRequest,
    CreateMessageRequestFromJSON,
    CreateMessageRequestToJSON,
} from '../models/CreateMessageRequest';
import {
    type Document,
    DocumentFromJSON,
    DocumentToJSON,
} from '../models/Document';
import {
    type DocumentUploadUrl,
    DocumentUploadUrlFromJSON,
    DocumentUploadUrlToJSON,
} from '../models/DocumentUploadUrl';
import {
    type GetDocumentDownloadUrl200Response,
    GetDocumentDownloadUrl200ResponseFromJSON,
    GetDocumentDownloadUrl200ResponseToJSON,
} from '../models/GetDocumentDownloadUrl200Response';
import {
    type InvitationVerification,
    InvitationVerificationFromJSON,
    InvitationVerificationToJSON,
} from '../models/InvitationVerification';
import {
    type ListDocuments200Response,
    ListDocuments200ResponseFromJSON,
    ListDocuments200ResponseToJSON,
} from '../models/ListDocuments200Response';
import {
    type ListInboundReferrals200Response,
    ListInboundReferrals200ResponseFromJSON,
    ListInboundReferrals200ResponseToJSON,
} from '../models/ListInboundReferrals200Response';
import {
    type ListMessages200Response,
    ListMessages200ResponseFromJSON,
    ListMessages200ResponseToJSON,
} from '../models/ListMessages200Response';
import {
    type ListOutboundReferrals200Response,
    ListOutboundReferrals200ResponseFromJSON,
    ListOutboundReferrals200ResponseToJSON,
} from '../models/ListOutboundReferrals200Response';
import {
    type ListReferralsByLead200Response,
    ListReferralsByLead200ResponseFromJSON,
    ListReferralsByLead200ResponseToJSON,
} from '../models/ListReferralsByLead200Response';
import {
    type Message,
    MessageFromJSON,
    MessageToJSON,
} from '../models/Message';
import {
    type ReadReceipt,
    ReadReceiptFromJSON,
    ReadReceiptToJSON,
} from '../models/ReadReceipt';
import {
    type Recipient,
    RecipientFromJSON,
    RecipientToJSON,
} from '../models/Recipient';
import {
    type RecipientReferralView,
    RecipientReferralViewFromJSON,
    RecipientReferralViewToJSON,
} from '../models/RecipientReferralView';
import {
    type ReferralDetail,
    ReferralDetailFromJSON,
    ReferralDetailToJSON,
} from '../models/ReferralDetail';
import {
    type UpdateReadReceiptRequest,
    UpdateReadReceiptRequestFromJSON,
    UpdateReadReceiptRequestToJSON,
} from '../models/UpdateReadReceiptRequest';
import {
    type UpdateRecipientStatusRequest,
    UpdateRecipientStatusRequestFromJSON,
    UpdateRecipientStatusRequestToJSON,
} from '../models/UpdateRecipientStatusRequest';
import {
    type UpdateReferralRequest,
    UpdateReferralRequestFromJSON,
    UpdateReferralRequestToJSON,
} from '../models/UpdateReferralRequest';
import {
    type VerifyInvitationRequest,
    VerifyInvitationRequestFromJSON,
    VerifyInvitationRequestToJSON,
} from '../models/VerifyInvitationRequest';

export interface CreateDocumentOperationRequest {
    /**
     * Referral identifier
     */
    referralId: string;
    /**
     * 
     */
    createDocumentRequest: CreateDocumentRequest;
}

export interface CreateDocumentUploadUrlOperationRequest {
    /**
     * Referral identifier
     */
    referralId: string;
    /**
     * 
     */
    createDocumentUploadUrlRequest: CreateDocumentUploadUrlRequest;
}

export interface CreateMessageOperationRequest {
    /**
     * Referral identifier
     */
    referralId: string;
    /**
     * 
     */
    createMessageRequest: CreateMessageRequest;
}

export interface GetDocumentDownloadUrlRequest {
    /**
     * Referral identifier
     */
    referralId: string;
    /**
     * 
     */
    documentId: string;
}

export interface GetRecipientReferralViewRequest {
    /**
     * Referral identifier
     */
    referralId: string;
}

export interface GetReferralRequest {
    /**
     * Referral identifier
     */
    referralId: string;
}

export interface ListDocumentsRequest {
    /**
     * Referral identifier
     */
    referralId: string;
    /**
     * Opaque pagination cursor from a previous response
     */
    cursor?: string;
    /**
     * Maximum number of items to return
     */
    limit?: number;
}

export interface ListInboundReferralsRequest {
    /**
     * Filter by recipient status
     */
    status?: ListInboundReferralsStatusEnum;
    /**
     * Opaque pagination cursor from a previous response
     */
    cursor?: string;
    /**
     * Maximum number of items to return
     */
    limit?: number;
}

export interface ListMessagesRequest {
    /**
     * Referral identifier
     */
    referralId: string;
    /**
     * Opaque pagination cursor from a previous response
     */
    cursor?: string;
    /**
     * Maximum number of items to return
     */
    limit?: number;
    /**
     * Filter messages to the facility-scoped thread identified by this receiver_facility_id. Global system messages without this field are always included.
     */
    receiverFacilityId?: string;
    /**
     * When combined with receiver_facility_id, enables bidirectional filtering — returns all messages between receiver_facility_id and sender_facility_id in either direction, plus global system messages. Both params must be provided together.
     */
    senderFacilityId?: string;
}

export interface ListOutboundReferralsRequest {
    /**
     * Filter by referral status
     */
    status?: ListOutboundReferralsStatusEnum;
    /**
     * Filter by sender facility. When omitted, returns referrals across
     * all facilities in the caller's organization.
     * 
     */
    facilityId?: string;
    /**
     * Deprecated — use `recipient_provider_ids`. External recipients are
     * identified here by a synthetic value, not a real facility ID.
     * 
     * Filter by recipient facility IDs (comma-separated). Returns referrals
     * that have at least one recipient in the specified facilities, scoped
     * to the caller's organization. Cursor pagination is supported only
     * when a single facility ID is provided.
     * 
     * @deprecated
     */
    recipientFacilityIds?: Array<string>;
    /**
     * Filter by recipient `provider_directory` IDs (comma-separated).
     * Returns referrals with at least one recipient matching one of the
     * given providers, scoped to the caller's organization. Maximum 10
     * IDs. Cursor pagination is supported only when a single ID is given.
     * 
     * Recipients with no provider ("other" recipients) cannot be
     * filtered on. Mutually exclusive with `recipient_facility_ids`.
     * 
     */
    recipientProviderIds?: Array<string>;
    /**
     * Opaque pagination cursor from a previous response
     */
    cursor?: string;
    /**
     * Maximum number of items to return
     */
    limit?: number;
}

export interface ListReferralsByLeadRequest {
    /**
     * Lead identifier
     */
    leadId: string;
}

export interface PatchRecipientStatusRequest {
    /**
     * Referral identifier
     */
    referralId: string;
    /**
     * 
     */
    updateRecipientStatusRequest: UpdateRecipientStatusRequest;
}

export interface ResendInvitationPasscodeRequest {
    /**
     * 
     */
    token: string;
}

export interface UpdateReferralOperationRequest {
    /**
     * Referral identifier
     */
    referralId: string;
    /**
     * 
     */
    updateReferralRequest: UpdateReferralRequest;
}

export interface UpsertReadReceiptRequest {
    /**
     * Referral identifier
     */
    referralId: string;
    /**
     * 
     */
    recipientFacilityId: string;
    /**
     * 
     */
    updateReadReceiptRequest: UpdateReadReceiptRequest;
}

export interface VerifyInvitationOperationRequest {
    /**
     * The inv_<random> token from the referral-access URL
     */
    token: string;
    /**
     * 
     */
    verifyInvitationRequest: VerifyInvitationRequest;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {

    /**
     * Creates request options for createDocument without sending the request
     */
    async createDocumentRequestOpts(requestParameters: CreateDocumentOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling createDocument().'
            );
        }

        if (requestParameters['createDocumentRequest'] == null) {
            throw new runtime.RequiredError(
                'createDocumentRequest',
                'Required parameter "createDocumentRequest" was null or undefined when calling createDocument().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals/{referral_id}/documents`;
        urlPath = urlPath.replace('{referral_id}', encodeURIComponent(String(requestParameters['referralId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDocumentRequestToJSON(requestParameters['createDocumentRequest']),
        };
    }

    /**
     * Attaches a document to a referral. Both the sender and recipient facilities can upload documents. JWT callers may provide sender_facility_id to specify which facility is uploading; if omitted, defaults to the referral sender facility. Invitation callers upload as the bound invitation recipient and may only provide sender_facility_id when it matches that recipient. 
     * Attach a document to a referral
     */
    async createDocumentRaw(requestParameters: CreateDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Document>> {
        const requestOptions = await this.createDocumentRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentFromJSON(jsonValue));
    }

    /**
     * Attaches a document to a referral. Both the sender and recipient facilities can upload documents. JWT callers may provide sender_facility_id to specify which facility is uploading; if omitted, defaults to the referral sender facility. Invitation callers upload as the bound invitation recipient and may only provide sender_facility_id when it matches that recipient. 
     * Attach a document to a referral
     */
    async createDocument(requestParameters: CreateDocumentOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Document> {
        const response = await this.createDocumentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createDocumentUploadUrl without sending the request
     */
    async createDocumentUploadUrlRequestOpts(requestParameters: CreateDocumentUploadUrlOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling createDocumentUploadUrl().'
            );
        }

        if (requestParameters['createDocumentUploadUrlRequest'] == null) {
            throw new runtime.RequiredError(
                'createDocumentUploadUrlRequest',
                'Required parameter "createDocumentUploadUrlRequest" was null or undefined when calling createDocumentUploadUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals/{referral_id}/documents/upload-url`;
        urlPath = urlPath.replace('{referral_id}', encodeURIComponent(String(requestParameters['referralId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateDocumentUploadUrlRequestToJSON(requestParameters['createDocumentUploadUrlRequest']),
        };
    }

    /**
     * Returns a short-lived presigned S3 PUT URL for a document that will be attached to the referral. The uploaded object lands directly in ROC\'s documents bucket at its final canonical key. Both JWT and invitation callers may use this endpoint. 
     * Get a presigned upload URL for a referral document
     */
    async createDocumentUploadUrlRaw(requestParameters: CreateDocumentUploadUrlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DocumentUploadUrl>> {
        const requestOptions = await this.createDocumentUploadUrlRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DocumentUploadUrlFromJSON(jsonValue));
    }

    /**
     * Returns a short-lived presigned S3 PUT URL for a document that will be attached to the referral. The uploaded object lands directly in ROC\'s documents bucket at its final canonical key. Both JWT and invitation callers may use this endpoint. 
     * Get a presigned upload URL for a referral document
     */
    async createDocumentUploadUrl(requestParameters: CreateDocumentUploadUrlOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DocumentUploadUrl> {
        const response = await this.createDocumentUploadUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for createMessage without sending the request
     */
    async createMessageRequestOpts(requestParameters: CreateMessageOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling createMessage().'
            );
        }

        if (requestParameters['createMessageRequest'] == null) {
            throw new runtime.RequiredError(
                'createMessageRequest',
                'Required parameter "createMessageRequest" was null or undefined when calling createMessage().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals/{referral_id}/messages`;
        urlPath = urlPath.replace('{referral_id}', encodeURIComponent(String(requestParameters['referralId'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateMessageRequestToJSON(requestParameters['createMessageRequest']),
        };
    }

    /**
     * Creates a new user message. JWT callers must provide both facility IDs. Invitation callers provide only content; sender and receiver facilities are inferred from the bound invitation recipient thread. 
     * Send a message to a referral thread
     */
    async createMessageRaw(requestParameters: CreateMessageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Message>> {
        const requestOptions = await this.createMessageRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MessageFromJSON(jsonValue));
    }

    /**
     * Creates a new user message. JWT callers must provide both facility IDs. Invitation callers provide only content; sender and receiver facilities are inferred from the bound invitation recipient thread. 
     * Send a message to a referral thread
     */
    async createMessage(requestParameters: CreateMessageOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Message> {
        const response = await this.createMessageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getDocumentDownloadUrl without sending the request
     */
    async getDocumentDownloadUrlRequestOpts(requestParameters: GetDocumentDownloadUrlRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling getDocumentDownloadUrl().'
            );
        }

        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling getDocumentDownloadUrl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals/{referral_id}/documents/{document_id}/download-url`;
        urlPath = urlPath.replace('{referral_id}', encodeURIComponent(String(requestParameters['referralId'])));
        urlPath = urlPath.replace('{document_id}', encodeURIComponent(String(requestParameters['documentId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns a short-lived (10 min) presigned S3 URL for the ROC-bucket copy of a document. Caller must be the sender or a recipient of the referral (enforced by referralAccess middleware). 
     * Get a presigned download URL for a referral document
     */
    async getDocumentDownloadUrlRaw(requestParameters: GetDocumentDownloadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetDocumentDownloadUrl200Response>> {
        const requestOptions = await this.getDocumentDownloadUrlRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetDocumentDownloadUrl200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns a short-lived (10 min) presigned S3 URL for the ROC-bucket copy of a document. Caller must be the sender or a recipient of the referral (enforced by referralAccess middleware). 
     * Get a presigned download URL for a referral document
     */
    async getDocumentDownloadUrl(requestParameters: GetDocumentDownloadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetDocumentDownloadUrl200Response> {
        const response = await this.getDocumentDownloadUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getRecipientReferralView without sending the request
     */
    async getRecipientReferralViewRequestOpts(requestParameters: GetRecipientReferralViewRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling getRecipientReferralView().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals/{referral_id}/recipient-view`;
        urlPath = urlPath.replace('{referral_id}', encodeURIComponent(String(requestParameters['referralId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Token-only endpoint. Returns the minimal referral and recipient metadata needed to render the external recipient view without exposing the full sender-side referral detail payload. 
     * Get minimal referral metadata for an invitation recipient
     */
    async getRecipientReferralViewRaw(requestParameters: GetRecipientReferralViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RecipientReferralView>> {
        const requestOptions = await this.getRecipientReferralViewRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RecipientReferralViewFromJSON(jsonValue));
    }

    /**
     * Token-only endpoint. Returns the minimal referral and recipient metadata needed to render the external recipient view without exposing the full sender-side referral detail payload. 
     * Get minimal referral metadata for an invitation recipient
     */
    async getRecipientReferralView(requestParameters: GetRecipientReferralViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RecipientReferralView> {
        const response = await this.getRecipientReferralViewRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for getReferral without sending the request
     */
    async getReferralRequestOpts(requestParameters: GetReferralRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling getReferral().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals/{referral_id}`;
        urlPath = urlPath.replace('{referral_id}', encodeURIComponent(String(requestParameters['referralId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns a single referral with its recipients. Returns 404 if the referral does not exist or the caller\'s organization does not have access. 
     * Get a referral by ID
     */
    async getReferralRaw(requestParameters: GetReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReferralDetail>> {
        const requestOptions = await this.getReferralRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferralDetailFromJSON(jsonValue));
    }

    /**
     * Returns a single referral with its recipients. Returns 404 if the referral does not exist or the caller\'s organization does not have access. 
     * Get a referral by ID
     */
    async getReferral(requestParameters: GetReferralRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReferralDetail> {
        const response = await this.getReferralRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listDocuments without sending the request
     */
    async listDocumentsRequestOpts(requestParameters: ListDocumentsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling listDocuments().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals/{referral_id}/documents`;
        urlPath = urlPath.replace('{referral_id}', encodeURIComponent(String(requestParameters['referralId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns a paginated list of documents attached to a referral.
     * List documents for a referral
     */
    async listDocumentsRaw(requestParameters: ListDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListDocuments200Response>> {
        const requestOptions = await this.listDocumentsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListDocuments200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns a paginated list of documents attached to a referral.
     * List documents for a referral
     */
    async listDocuments(requestParameters: ListDocumentsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListDocuments200Response> {
        const response = await this.listDocumentsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listInboundReferrals without sending the request
     */
    async listInboundReferralsRequestOpts(requestParameters: ListInboundReferralsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals/inbound`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns a paginated list of referrals where the caller\'s organization is a recipient. Each item contains the recipient record with a nested referral object (nullable when the parent referral is missing). Organization is determined from the JWT. 
     * List inbound referrals
     */
    async listInboundReferralsRaw(requestParameters: ListInboundReferralsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListInboundReferrals200Response>> {
        const requestOptions = await this.listInboundReferralsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListInboundReferrals200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns a paginated list of referrals where the caller\'s organization is a recipient. Each item contains the recipient record with a nested referral object (nullable when the parent referral is missing). Organization is determined from the JWT. 
     * List inbound referrals
     */
    async listInboundReferrals(requestParameters: ListInboundReferralsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListInboundReferrals200Response> {
        const response = await this.listInboundReferralsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listMessages without sending the request
     */
    async listMessagesRequestOpts(requestParameters: ListMessagesRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling listMessages().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['receiverFacilityId'] != null) {
            queryParameters['receiver_facility_id'] = requestParameters['receiverFacilityId'];
        }

        if (requestParameters['senderFacilityId'] != null) {
            queryParameters['sender_facility_id'] = requestParameters['senderFacilityId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals/{referral_id}/messages`;
        urlPath = urlPath.replace('{referral_id}', encodeURIComponent(String(requestParameters['referralId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns a paginated list of messages sorted chronologically (oldest first).
     * List messages for a referral
     */
    async listMessagesRaw(requestParameters: ListMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListMessages200Response>> {
        const requestOptions = await this.listMessagesRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListMessages200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns a paginated list of messages sorted chronologically (oldest first).
     * List messages for a referral
     */
    async listMessages(requestParameters: ListMessagesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListMessages200Response> {
        const response = await this.listMessagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listOutboundReferrals without sending the request
     */
    async listOutboundReferralsRequestOpts(requestParameters: ListOutboundReferralsRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['facilityId'] != null) {
            queryParameters['facility_id'] = requestParameters['facilityId'];
        }

        if (requestParameters['recipientFacilityIds'] != null) {
            queryParameters['recipient_facility_ids'] = requestParameters['recipientFacilityIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['recipientProviderIds'] != null) {
            queryParameters['recipient_provider_ids'] = requestParameters['recipientProviderIds']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['cursor'] != null) {
            queryParameters['cursor'] = requestParameters['cursor'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals/outbound`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns a paginated list of referrals sent by the caller\'s organization. Organization is determined from the JWT. When `facility_id` is provided, results are scoped to referrals sent from that facility. When `recipient_provider_ids` is provided, results are scoped to referrals that have at least one recipient from the given providers (partner portal use case). When both are present, both filters are applied — only referrals sent from `facility_id` that also have a matching recipient are returned. `recipient_facility_ids` is the deprecated form of the recipient filter.
     * List outbound referrals
     */
    async listOutboundReferralsRaw(requestParameters: ListOutboundReferralsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListOutboundReferrals200Response>> {
        const requestOptions = await this.listOutboundReferralsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListOutboundReferrals200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns a paginated list of referrals sent by the caller\'s organization. Organization is determined from the JWT. When `facility_id` is provided, results are scoped to referrals sent from that facility. When `recipient_provider_ids` is provided, results are scoped to referrals that have at least one recipient from the given providers (partner portal use case). When both are present, both filters are applied — only referrals sent from `facility_id` that also have a matching recipient are returned. `recipient_facility_ids` is the deprecated form of the recipient filter.
     * List outbound referrals
     */
    async listOutboundReferrals(requestParameters: ListOutboundReferralsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListOutboundReferrals200Response> {
        const response = await this.listOutboundReferralsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for listReferralsByLead without sending the request
     */
    async listReferralsByLeadRequestOpts(requestParameters: ListReferralsByLeadRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['leadId'] == null) {
            throw new runtime.RequiredError(
                'leadId',
                'Required parameter "leadId" was null or undefined when calling listReferralsByLead().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals/by-lead/{lead_id}`;
        urlPath = urlPath.replace('{lead_id}', encodeURIComponent(String(requestParameters['leadId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns a non-paginated list of referrals associated with the given lead, filtered to only those the caller\'s organization can access (as sender or recipient). Organization is determined from the JWT. 
     * List referrals for a lead
     */
    async listReferralsByLeadRaw(requestParameters: ListReferralsByLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListReferralsByLead200Response>> {
        const requestOptions = await this.listReferralsByLeadRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListReferralsByLead200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns a non-paginated list of referrals associated with the given lead, filtered to only those the caller\'s organization can access (as sender or recipient). Organization is determined from the JWT. 
     * List referrals for a lead
     */
    async listReferralsByLead(requestParameters: ListReferralsByLeadRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListReferralsByLead200Response> {
        const response = await this.listReferralsByLeadRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for patchRecipientStatus without sending the request
     */
    async patchRecipientStatusRequestOpts(requestParameters: PatchRecipientStatusRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling patchRecipientStatus().'
            );
        }

        if (requestParameters['updateRecipientStatusRequest'] == null) {
            throw new runtime.RequiredError(
                'updateRecipientStatusRequest',
                'Required parameter "updateRecipientStatusRequest" was null or undefined when calling patchRecipientStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals/{referral_id}/recipient-status`;
        urlPath = urlPath.replace('{referral_id}', encodeURIComponent(String(requestParameters['referralId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateRecipientStatusRequestToJSON(requestParameters['updateRecipientStatusRequest']),
        };
    }

    /**
     * Token-only endpoint (V1). Updates the recipient row for the external recipient identified by the invitation token. Publishes an outbound SNS event and emits an audit log entry. 
     * Update the recipient status for the invitation caller
     */
    async patchRecipientStatusRaw(requestParameters: PatchRecipientStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Recipient>> {
        const requestOptions = await this.patchRecipientStatusRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RecipientFromJSON(jsonValue));
    }

    /**
     * Token-only endpoint (V1). Updates the recipient row for the external recipient identified by the invitation token. Publishes an outbound SNS event and emits an audit log entry. 
     * Update the recipient status for the invitation caller
     */
    async patchRecipientStatus(requestParameters: PatchRecipientStatusRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Recipient> {
        const response = await this.patchRecipientStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for resendInvitationPasscode without sending the request
     */
    async resendInvitationPasscodeRequestOpts(requestParameters: ResendInvitationPasscodeRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling resendInvitationPasscode().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/invitations/{token}/resend`;
        urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Public endpoint — no authorizer or passcode required. Requests are rate-limited per invitation and always receive the same response to avoid disclosing invitation state. 
     * Resend an invitation passcode email
     */
    async resendInvitationPasscodeRaw(requestParameters: ResendInvitationPasscodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.resendInvitationPasscodeRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Public endpoint — no authorizer or passcode required. Requests are rate-limited per invitation and always receive the same response to avoid disclosing invitation state. 
     * Resend an invitation passcode email
     */
    async resendInvitationPasscode(requestParameters: ResendInvitationPasscodeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.resendInvitationPasscodeRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for updateReferral without sending the request
     */
    async updateReferralRequestOpts(requestParameters: UpdateReferralOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling updateReferral().'
            );
        }

        if (requestParameters['updateReferralRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReferralRequest',
                'Required parameter "updateReferralRequest" was null or undefined when calling updateReferral().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals/{referral_id}`;
        urlPath = urlPath.replace('{referral_id}', encodeURIComponent(String(requestParameters['referralId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReferralRequestToJSON(requestParameters['updateReferralRequest']),
        };
    }

    /**
     * Updates a referral\'s discharge date. Only the sender organization can update referrals. Returns 403 if the caller is not the sender organization. 
     * Update a referral
     */
    async updateReferralRaw(requestParameters: UpdateReferralOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.updateReferralRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates a referral\'s discharge date. Only the sender organization can update referrals. Returns 403 if the caller is not the sender organization. 
     * Update a referral
     */
    async updateReferral(requestParameters: UpdateReferralOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateReferralRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for upsertReadReceipt without sending the request
     */
    async upsertReadReceiptRequestOpts(requestParameters: UpsertReadReceiptRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['referralId'] == null) {
            throw new runtime.RequiredError(
                'referralId',
                'Required parameter "referralId" was null or undefined when calling upsertReadReceipt().'
            );
        }

        if (requestParameters['recipientFacilityId'] == null) {
            throw new runtime.RequiredError(
                'recipientFacilityId',
                'Required parameter "recipientFacilityId" was null or undefined when calling upsertReadReceipt().'
            );
        }

        if (requestParameters['updateReadReceiptRequest'] == null) {
            throw new runtime.RequiredError(
                'updateReadReceiptRequest',
                'Required parameter "updateReadReceiptRequest" was null or undefined when calling upsertReadReceipt().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("BearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/referrals/{referral_id}/threads/{recipient_facility_id}/read-receipts`;
        urlPath = urlPath.replace('{referral_id}', encodeURIComponent(String(requestParameters['referralId'])));
        urlPath = urlPath.replace('{recipient_facility_id}', encodeURIComponent(String(requestParameters['recipientFacilityId'])));

        return {
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateReadReceiptRequestToJSON(requestParameters['updateReadReceiptRequest']),
        };
    }

    /**
     * Creates or updates the caller\'s read position for a specific recipient thread. user_id and user_facility_id are derived server-side from the JWT and referral; callers do not supply them. 
     * Mark messages as read in a recipient thread
     */
    async upsertReadReceiptRaw(requestParameters: UpsertReadReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReadReceipt>> {
        const requestOptions = await this.upsertReadReceiptRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReadReceiptFromJSON(jsonValue));
    }

    /**
     * Creates or updates the caller\'s read position for a specific recipient thread. user_id and user_facility_id are derived server-side from the JWT and referral; callers do not supply them. 
     * Mark messages as read in a recipient thread
     */
    async upsertReadReceipt(requestParameters: UpsertReadReceiptRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReadReceipt> {
        const response = await this.upsertReadReceiptRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for verifyInvitation without sending the request
     */
    async verifyInvitationRequestOpts(requestParameters: VerifyInvitationOperationRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['token'] == null) {
            throw new runtime.RequiredError(
                'token',
                'Required parameter "token" was null or undefined when calling verifyInvitation().'
            );
        }

        if (requestParameters['verifyInvitationRequest'] == null) {
            throw new runtime.RequiredError(
                'verifyInvitationRequest',
                'Required parameter "verifyInvitationRequest" was null or undefined when calling verifyInvitation().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/invitations/{token}`;
        urlPath = urlPath.replace('{token}', encodeURIComponent(String(requestParameters['token'])));

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VerifyInvitationRequestToJSON(requestParameters['verifyInvitationRequest']),
        };
    }

    /**
     * Public endpoint — no authorizer. Validates the invitation token and passcode, then issues a session token for invitation-backed referral requests. Invalid, expired, revoked, and incorrect-passcode attempts receive the same unauthorized response. 
     * Verify an invitation passcode and issue a session
     */
    async verifyInvitationRaw(requestParameters: VerifyInvitationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InvitationVerification>> {
        const requestOptions = await this.verifyInvitationRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InvitationVerificationFromJSON(jsonValue));
    }

    /**
     * Public endpoint — no authorizer. Validates the invitation token and passcode, then issues a session token for invitation-backed referral requests. Invalid, expired, revoked, and incorrect-passcode attempts receive the same unauthorized response. 
     * Verify an invitation passcode and issue a session
     */
    async verifyInvitation(requestParameters: VerifyInvitationOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InvitationVerification> {
        const response = await this.verifyInvitationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const ListInboundReferralsStatusEnum = {
    Pending: 'pending',
    Accepted: 'accepted',
    Declined: 'declined',
} as const;
export type ListInboundReferralsStatusEnum = typeof ListInboundReferralsStatusEnum[keyof typeof ListInboundReferralsStatusEnum];
/**
 * @export
 */
export const ListOutboundReferralsStatusEnum = {
    Draft: 'draft',
    Sent: 'sent',
    Confirmed: 'confirmed',
    Closed: 'closed',
} as const;
export type ListOutboundReferralsStatusEnum = typeof ListOutboundReferralsStatusEnum[keyof typeof ListOutboundReferralsStatusEnum];
